import React, { useEffect } from 'react';
import Hero from '../../components/hero/Hero';
import Works from '../../components/works/Works';
import Nav from '../../components/nav/Nav';
import BotDiv from '../../components/botdiv/BotDiv';
import Loader from '../../components/preloader/Loader';

function Home({ loaderFinished, setLoaderFinished }) {
  useEffect(()=>{
    setLoaderFinished(false);
  },[setLoaderFinished]);
  return (
    <div>
        <Loader loaderFinished={setLoaderFinished} show2={true}/>
        {loaderFinished && (
          <>
              <Nav inHome={true}/>
              <Hero/>
              <Works/>
              <BotDiv/>
          </>
        )}
    </div>
  )
}

export default Home;
